<div class="d-flex justify-content-start align-items-center pb-3">
  @if (!isPolicyPrevidenziale) {
    <h6>Inserire importo premio e/o periodicità:</h6>
  } @else {
    <h6>Scegliere cosa variare:</h6>
  }
</div>
<app-basic-form
  [form]="variationOptionsForm"
  [keys]="variationOptionsFormKeys"
></app-basic-form>
@if(showMainForm) {
  <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
}
